import { IListElement } from '@srm/ui/types/IListElement';

export const NoActionsItem: IListElement = {
    label: 'Нет доступных действий',
    value: 'no_actions',
};
